import RssFeedIcon from "@mui/icons-material/RssFeed";
import useExcelUrl from "app/useExcelUrl";
import {
  DataGridV2 as DataGrid,
  DataGridBaseBaseProps,
  DataGridModalEditColumn,
  GridColumns,
  PageHeader,
} from "common";
import useAccess from "features/profile/useAccess";
import I18n from "i18n";
import { PartnerFeedItem } from "./partnerFeedApi";
import PartnerFeedForm from "./PartnerFeedForm";
import usePartnerFeedList from "./usePartnerFeedList";

export interface PartnerFeedListProps
  extends Omit<DataGridBaseBaseProps, "id"> {
  showHeader?: boolean;
}

export default function PartnerFeedList({
  showHeader = true,
  ...props
}: PartnerFeedListProps) {
  const { params, scope, editUrl, ...service } = usePartnerFeedList();
  const { hasPermissions, canEditItem } = useAccess();
  const excelUrl = useExcelUrl("partner-feeds");

  let columns: GridColumns<PartnerFeedItem> = [
    {
      field: "title",
      headerName: I18n.t("PartnerFeed.attributes.title"),
      renderCell: params => (
        <DataGridModalEditColumn
          href={`${editUrl}${params.row?.id}`}
          params={params}
        />
      ),
      flex: 1,
    },
    {
      field: "description",
      headerName: I18n.t("PartnerFeed.attributes.description"),
      flex: 2,
    },
    {
      field: "file.name",
      headerName: I18n.t("PartnerFeed.attributes.file_id"),
      flex: 1,
    },
    {
      field: "created_at",
      headerName: I18n.t("PartnerFeed.attributes.created_at"),
      type: "dateTime",
      flex: 1,
    },
  ];

  return (
    <>
      {showHeader && (
        <PageHeader
          avatar={<RssFeedIcon />}
          title={I18n.t("PartnerFeed.title")}
        />
      )}
      <DataGrid
        {...service}
        columns={columns}
        id="partner-feeds"
        excelUrl={excelUrl}
        renderModalForm={props => <PartnerFeedForm {...props} />}
        modalProps={{ maxWidth: "md" }}
        {...props}
        defaultState={{
          sorting: [{ field: "created_at", direction: "desc" }],
        }}
        canCreate={hasPermissions("partner_feed.create")}
        canDelete={hasPermissions([
          "partner_feed.editany",
          "partner_feed.editown",
        ])}
        canEdit={hasPermissions([
          "partner_feed.editany",
          "partner_feed.editown",
        ])}
        canDeleteRow={params => canEditItem("partner_feed", params.row)}
        canEditRow={params => canEditItem("partner_feed", params.row)}
        canBatchActions={hasPermissions([
          "partner_feed.editany",
          "partner_feed.editown",
        ])}
        canHandleTrash={hasPermissions([
          "partner_feed.editany",
          "partner_feed.editown",
        ])}
      />
    </>
  );
}
